export const getTotalDuration = (seconds: number | undefined) => `00:${(seconds ?? 0) < 10 ? `0${seconds}` : seconds}`
